import React, { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Prev from '../../../../../Assets/Modals/Prev.svg';
import Next from '../../../../../Assets/Modals/Next.svg';
import Bucket from '../../../../../Assets/Lens/Bucket.svg';
import Input from './Input';
import SingleImageForm from './SingleImageForm';
import MultipleMediaSection from './MultipleMediaSection';
import { clearImages, selectTagListProduct } from '../../../../../Features/lensSlice';
import { ImageContext } from '../../../../../Context/ImagesContext';
import LoadingScene from '../../../../../Components/LensLoadingScene/LoadingScene';

function DefaultPost() {
    const dispatch = useDispatch();

    const { setImagesList, postingImagesLoading } = useContext(ImageContext);

    const images = useSelector((state) => state.lens.media.images);
    const taggedProduct = useSelector((state) => state.lens.tagList.product);

    const [slide, setSlide] = useState(0);

    const deleteImage = () => {
        dispatch(clearImages());
        dispatch(selectTagListProduct(taggedProduct));
        setImagesList([]);
    }

    const forwardSlide = () => {
        if (slide === images.length - 1) {
            setSlide(0);
        } else {
            setSlide(slide + 1);
        }
    };

    const backwardSlide = () => {
        if (slide === 0) {
            setSlide(images.length - 1);
        } else {
            setSlide(slide - 1);
        }
    };

    useEffect(() => {
        if(slide === 0) {
            setSlide(0);
        }
        else {
            setSlide(slide - 1);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [images]);

    return (
        <div className='w-3/4 max-[1280px]:w-[85%] h-[84%] flex overflow-hidden rounded-xl bg-[#FFFFFF]'>
            <div className="w-3/5 relative h-full bg-[#EAEAEA] flex items-center justify-center">
                {!images.length ? <h1 className='font-normal italic text-[20px] leading-6 text-[#666666]'>Image Preview</h1> : 
                    <>
                        <div className="h-full w-full flex items-center justify-center">
                            {images?.map((item, index) => {
                                return (
                                    <img key={item.id} className={`max-h-full max-w-full ${slide === index ? '' : 'hidden'}`} src={item.url} alt={item.id} />
                                );
                            })}
                        </div>

                        {images.length > 1 &&
                            <>
                                <button onClick={backwardSlide} className="rounded-full bg-[#FFFFFF8A] hover:bg-[#FFFFFFBC] absolute top-1/2 left-3 -translate-y-1/2 w-11 h-11 flex items-center justify-center">
                                    <img src={Prev} alt="" />
                                </button>

                                <button onClick={forwardSlide} className="rounded-full bg-[#FFFFFF8A] hover:bg-[#FFFFFFBC] absolute top-1/2 right-3 -translate-y-1/2 w-11 h-11 flex items-center justify-center">
                                    <img src={Next} alt="" />
                                </button>
                            </>
                        }
                    </>
                }

                {
                    images.length === 1 && 
                    <button onClick={deleteImage} className="absolute top-4 right-4 w-8 h-8 flex items-center justify-center rounded-full bg-[#EF4444]">
                        <div className="w-[18px] h-[18px] flex items-center justify-center">
                            <img src={Bucket} alt="" />
                        </div>
                    </button>
                }
            </div>

            {!images.length ? 
                <Input /> : 
                (
                    images.length > 1 ? 
                    <MultipleMediaSection /> : 
                    <>
                        {
                            postingImagesLoading ? 
                            <LoadingScene /> : 
                            <SingleImageForm />
                        }
                    </>
                )
            }
        </div>
    );
}

export default DefaultPost;
